import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { toast } from 'sonner';

export const EmailWithCopy = ({ email }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      toast.success('E-mail copiado!');
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      // Fallback para navegadores sem clipboard API
      const ta = document.createElement('textarea');
      ta.value = email;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); toast.success('E-mail copiado!'); } catch (_) {}
      document.body.removeChild(ta);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  };

  return (
    <div className="flex items-center gap-1 break-all">
      <span>✉️ {email}</span>
      <button
        type="button"
        onClick={handleCopy}
        onDoubleClick={(e) => { e.stopPropagation(); e.preventDefault(); }}
        title="Copiar e-mail"
        data-testid="copy-customer-email-btn"
        className="inline-flex items-center justify-center shrink-0 rounded p-0.5 text-zinc-400 hover:text-indigo-600 hover:bg-indigo-50 transition-colors"
      >
        {copied
          ? <Check className="w-3 h-3 text-green-600" />
          : <Copy className="w-3 h-3" />}
      </button>
    </div>
  );
};

export default EmailWithCopy;
